<div class="mt-3">
    <div class="vehicle-transport__top-actions">
        <div class="btn-back text-bold cursor-pointer" (click)="goBack()">
            <i class="fa fa-arrow-left"></i> Volver al detalle del servicio
        </div>
        <div *ngIf="hasCreationPermission" [matTooltip]="isDisabledCreateApplication().reason"
            matTooltipClass="tooltip__error">
            <button (click)="onCreateApplication()" mat-raised-button type="button" class="button-width-auto"
                [disabled]="isDisabledCreateApplication().isDisabled">
                <i class="fas fa-plus-circle font-primary-dark"></i>
                <span class="font-primary-dark">Crear postulación</span>
            </button>
        </div>
    </div>

    <div class="vehicle-transport">
        <mat-accordion *ngIf="request" class="vehicle-transport__accordion">
            <mat-expansion-panel [expanded]="true" class="vehicle-transport__panel">
                <mat-expansion-panel-header>
                    <mat-panel-title class="text-bold">Detalle del servicio</mat-panel-title>
                </mat-expansion-panel-header>

                <div class="vehicle-transport__header">
                    <div class="col-12 col-md-6 col-lg-3">
                        <small>ID</small>
                        <p class="text-bold underline cursor-pointer" (click)="utils.openCargoNewTab(request)">
                            {{request.consecutive}}
                        </p>
                    </div>
                    <div class="col-12 col-md-6 col-lg-3">
                        <small>Cliente</small>
                        <p class="text-bold">{{request.cargoOwner?.name || '-'}}</p>
                    </div>
                    <div class="col-12 col-md-6 col-lg-3">
                        <small>Estado</small>
                        <p class="text-bold">{{cargoState || '-'}}</p>
                    </div>
                    <div class="col-12 col-md-6 col-lg-3">
                        <small>Perfil de riesgo</small>
                        <p class="text-bold">{{request.riskProfile?.name || '-'}}</p>
                    </div>
                    <div class="col-12 col-md-6 col-lg-3">
                        <small>Origen</small>
                        <p class="text-bold">{{request.cargoFeature?.uploadDownload?.origin?.name || '-'}}</p>
                    </div>
                    <div class="col-12 col-md-6 col-lg-3">
                        <small>Fecha de cargue</small>
                        <p class="text-bold">{{request.dateLoad | dateFormat:'only-date'}}</p>
                    </div>
                    <div class="col-12 col-md-6 col-lg-3">
                        <small>Destino</small>
                        <p class="text-bold">
                            {{lastDestination?.name || '-'}}
                        </p>
                    </div>
                    <div class="col-12 col-md-6 col-lg-3">
                        <small>Fecha de descargue</small>
                        <p class="text-bold">
                            {{lastDestination?.downloadDate | dateFormat:'only-date' || '-'}}
                        </p>
                    </div>
                    <div class="col-12 col-md-6 col-lg-3">
                        <small>Tipo de vehículo</small>
                        <p class="text-bold">{{request.cargoFeature?.vehicleType?.name || '-'}}</p>
                    </div>
                    <div class="col-12 col-md-6 col-lg-3">
                        <small>Tipo de carrocería</small>
                        <p class="text-bold">{{request.cargoFeature?.vehicleType?.bodyWorkType?.name || '-'}}</p>
                    </div>
                    <div class="col-12 col-md-6 col-lg-3">
                        <small>Peso total</small>
                        <p class="text-bold">{{request.cargoFeature?.cargoMeasure?.totalWeigth || '-'}}</p>
                    </div>
                    <div class="col-12 col-md-6 col-lg-3">
                        <small>Flete</small>
                        <p class="text-bold">{{cargoItemService.getRealCost(request) | currency:'COP':'code'}}</p>
                    </div>
                    <div class="col-12" *ngIf="request.observation">
                        <small>Observaciones</small>
                        <p class="text-bold">{{request.observation}}</p>
                    </div>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
        <div class="alert alert-warning text-center text-bold mt-3" role="alert"
            *ngIf="request && !hasAvailableActions.available">
            <i class="fas fa-exclamation-triangle mr-1"></i>
            {{hasAvailableActions.reason}}
        </div>

        <div class="vehicle-transport__toolbar"
            *ngIf="createdApplications?.length || refusedApplications?.length">
            <div class="vehicle-transport__filter-container">
                <mat-form-field appearance="outline" class="vehicle-transport__filter-field col-sm-4 col-12">
                    <mat-label>Tipo de postulación</mat-label>
                    <mat-select [(value)]="applicationTypeFilter">
                        <mat-option value="Created">Abiertas</mat-option>
                        <mat-option value="Refuse">Cerradas</mat-option>
                        <mat-option value="All">Todas</mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="outline" class="vehicle-transport__filter-field col-sm-4 col-12">
                    <mat-label>Ordenar por</mat-label>
                    <mat-select [value]="sortBy" (selectionChange)="onSortChange($event.value)">
                        <mat-option value="date">Fecha</mat-option>
                        <mat-option value="companyTrips">Viajes cliente</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="vehicle-transport__refresh-all-action" *ngIf="hasEditPermission">
                <button mat-raised-button type="button" class="vehicle-transport__enrich-button"
                    (click)="onRefreshAllApplications()"
                    matTooltip="Actualizar datos de todas las postulaciones">
                    <i class="fas fa-cloud-download-alt"></i>
                    <span>Actualizar datos</span>
                </button>
            </div>
        </div>

        <h4 class="text-bold mt-4 vehicle-transport__section-title vehicle-transport__section-title--open d-flex align-items-center mb-0"
            *ngIf="showCreatedApplications">
            <span class="flex-grow-1 text-center">Postulaciones abiertas</span>
            <button mat-icon-button type="button" class="vehicle-transport__reload-list-button"
                matTooltip="Refrescar listado de postulaciones abiertas"
                (click)="refreshApplications('Created')">
                <i class="fas fa-sync-alt"></i>
            </button>
        </h4>
        <div class="vehicle-transport__body vehicle-transport__body--open" *ngIf="showCreatedApplications">
            <ng-container *ngTemplateOutlet="applicationsTable; context: {
                applicationsList: createdApplications,
                sectionType: 'created',
                emptyMessage: 'No hay postulaciones abiertas'
            }"></ng-container>
        </div>
        <h4 class="text-bold mt-5 vehicle-transport__section-title vehicle-transport__section-title--closed d-flex align-items-center mb-0"
            *ngIf="showRefusedApplications">
            <span class="flex-grow-1 text-center">Postulaciones cerradas</span>
            <button mat-icon-button type="button" class="vehicle-transport__reload-list-button"
                matTooltip="Refrescar listado de postulaciones cerradas"
                (click)="refreshApplications('Refuse')">
                <i class="fas fa-sync-alt"></i>
            </button>
        </h4>
        <div class="vehicle-transport__body vehicle-transport__body--closed" *ngIf="showRefusedApplications">
            <ng-container *ngTemplateOutlet="applicationsTable; context: {
                applicationsList: refusedApplications,
                sectionType: 'closed',
                emptyMessage: 'No hay postulaciones cerradas'
            }"></ng-container>
        </div>
    </div>
</div>

<ng-template #applicationsTable let-applicationsList="applicationsList" let-sectionType="sectionType"
    let-emptyMessage="emptyMessage">
    <div class="vehicle-transport__table-container" *ngIf="applicationsList?.length"
        [ngClass]="{'vehicle-transport__table-container--open': sectionType === 'created', 'vehicle-transport__table-container--closed': sectionType === 'closed'}">
        <table mat-table [dataSource]="applicationsList" class="vehicle-transport__table">
            <ng-container matColumnDef="date">
                <th mat-header-cell *matHeaderCellDef>Fecha</th>
                <td mat-cell *matCellDef="let application">
                    <small>
                        {{application?.fingerprint?.date ? (application?.fingerprint?.date |
                        dateFormat:'date-time-full') : '-'}}
                    </small>
                </td>
            </ng-container>

            <ng-container matColumnDef="licensePlate">
                <th mat-header-cell *matHeaderCellDef>Placa</th>
                <td mat-cell *matCellDef="let application"
                    [ngClass]="{'underline cursor-pointer': !!application?.licensePlate}"
                    (click)="getDetailVehicle(application)">
                    {{application?.licensePlate || '-'}}
                </td>
            </ng-container>

            <ng-container matColumnDef="vehicleType">
                <th mat-header-cell *matHeaderCellDef>Tipo de vehículo</th>
                <td mat-cell *matCellDef="let application"
                    [ngClass]="{'color-alert': getVehicleType(application).isDifferent}">
                    {{getVehicleType(application).vehicleType || '-'}}</td>
            </ng-container>

            <ng-container matColumnDef="bodyWorkType">
                <th mat-header-cell *matHeaderCellDef>Tipo de carrocería</th>
                <td mat-cell *matCellDef="let application"
                    [ngClass]="{'color-alert': getBodyWorkType(application).isDifferent}">
                    {{getBodyWorkType(application).bodyWorkType || '-'}}</td>
            </ng-container>

            <ng-container matColumnDef="applicantId">
                <th mat-header-cell *matHeaderCellDef>ID Conductor</th>
                <td mat-cell *matCellDef="let application">{{application?.applicantId || '-'}}</td>
            </ng-container>

            <ng-container matColumnDef="phone">
                <th mat-header-cell *matHeaderCellDef>Cel. Conductor</th>
                <td mat-cell *matCellDef="let application">{{application?.phone || '-'}}</td>
            </ng-container>

            <ng-container matColumnDef="loadCapacity">
                <th mat-header-cell *matHeaderCellDef>Capacidad</th>
                <td mat-cell *matCellDef="let application"
                    [ngClass]="{'color-alert': getLoadCapacity(application).isLess}">
                    {{getLoadCapacity(application).loadCapacity || '-'}}</td>
            </ng-container>

            <ng-container matColumnDef="freight">
                <th mat-header-cell *matHeaderCellDef>Oferta</th>
                <td mat-cell *matCellDef="let application" [ngClass]="{'color-alert': getOffer(application).isMore}">
                    {{getOffer(application).offer | currency:'COP':'code'}}</td>
            </ng-container>

            <ng-container matColumnDef="numberOfTripsApp">
                <th mat-header-cell *matHeaderCellDef>Viajes empresa</th>
                <td mat-cell *matCellDef="let application">{{application?.numberOfTripsApp || '0'}}</td>
            </ng-container>

            <ng-container matColumnDef="numberOfTripsRNDC">
                <th mat-header-cell *matHeaderCellDef>Viajes RNDC</th>
                <td mat-cell *matCellDef="let application">{{application?.numberOfTripsRNDC || '0'}}</td>
            </ng-container>

            <ng-container matColumnDef="companyTrips">
                <th mat-header-cell *matHeaderCellDef>Viajes cliente</th>
                <td mat-cell *matCellDef="let application"
                    [ngClass]="{'color-alert': getCompanyTrips(application).isDifferent}">
                    {{getCompanyTrips(application).companyTrips || '0'}}</td>
            </ng-container>

            <ng-container matColumnDef="applicantScore">
                <th mat-header-cell *matHeaderCellDef>Puntaje</th>
                <td mat-cell *matCellDef="let application">{{application?.applicantScore || '-'}}</td>
            </ng-container>

            <ng-container matColumnDef="refuseReason">
                <th mat-header-cell *matHeaderCellDef>Motivo de rechazo</th>
                <td mat-cell *matCellDef="let application" [matTooltip]="getRefuseReason(application).completeReason"
                    matTooltipClass="tooltip__alert" class="cursor-pointer underline">
                    {{getRefuseReason(application).shortReason || '-'}}</td>
            </ng-container>

            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef class="vehicle-transport__sticky-column">Acciones</th>
                <td mat-cell *matCellDef="let application; let i = index" class="vehicle-transport__sticky-column">
                    <button mat-icon-button [matMenuTriggerFor]="rowActionsMenu" aria-label="Acciones">
                        <i class="fas fa-ellipsis-v"></i>
                    </button>
                    <mat-menu #rowActionsMenu="matMenu">
                        <button mat-menu-item (click)="getDetailVehicle(application)">Ver detalle del vehículo</button>
                        <button mat-menu-item (click)="onRefreshApplication(application)" *ngIf="hasEditPermission">
                            <i class="fas fa-sync-alt mr-1"></i> Actualizar
                        </button>
                        <div *ngIf="sectionType === 'created'" [matTooltip]="isDisabledRefuse(application).reason"
                            matTooltipClass="tooltip__error">
                            <button mat-menu-item [disabled]="isDisabledRefuse(application).isDisabled"
                                (click)="onRefuse(application)">
                                <i class="fas fa-times mr-1"></i> Rechazar
                            </button>
                        </div>
                        <div *ngIf="sectionType === 'created' && hasEditPermission"
                            [matTooltip]="isDisabledEditApplication().reason" matTooltipClass="tooltip__error">
                            <button mat-menu-item [disabled]="isDisabledEditApplication().isDisabled"
                                (click)="onEditApplication(application)">
                                <i class="fas fa-pencil-alt mr-1"></i> Editar
                            </button>
                        </div>
                        <div *ngIf="sectionType === 'created'" [matTooltip]="isDisabledAssign(application, i).reason"
                            matTooltipClass="tooltip__error">
                            <button mat-menu-item [disabled]="isDisabledAssign(application, i).isDisabled"
                                (click)="onAccepted(application)">
                                <i class="fas fa-check mr-1"></i> Asignar
                            </button>
                        </div>
                        <div *ngIf="sectionType === 'closed'" [matTooltip]="isDisabledRestore(application).reason"
                            matTooltipClass="tooltip__error">
                            <button mat-menu-item [disabled]="isDisabledRestore(application).isDisabled"
                                (click)="onRestore(application)">
                                <i class="fas fa-undo mr-1"></i> Restaurar
                            </button>
                        </div>
                    </mat-menu>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="tableColumns(sectionType, applicationsList)"></tr>
            <tr mat-row *matRowDef="let row; let odd = odd; columns: tableColumns(sectionType, applicationsList)"
                [ngClass]="{'vehicle-transport__row--odd': odd}"></tr>
        </table>
    </div>
    <div class="vehicle-transport__bottom-actions" *ngIf="sectionType === 'created' && applicationsList?.length">
        <div [matTooltip]="isDisabledRefuseAll(applicationsList).reason" matTooltipClass="tooltip__error">
            <p class="text-bold color-alert cursor-pointer" (click)="onRefuseAll(applicationsList)">Rechazar todas</p>
        </div>
    </div>

    <div *ngIf="!applicationsList?.length" class="vehicle-transport__watermark">
        <i class="fas fa-info-circle"></i>
        {{emptyMessage}}
    </div>
</ng-template>